export const newModal = <T extends Modal>(props: Partial<T> = {}) => {
  return {
    isOpen: false,
    ...props,
  } as T;
};
